import {
  SET_FEATURED_INSTAGRAM_POST,
  SET_ABOUT_US_ENTITIES,
  SET_ELASTICSEARCH_ENABLED,
} from "../actions/generalActions";

const defaultState = {
  featuredInstagramPosts: [],
  aboutUsEntities: [],
  elasticSearchEnabled: false,
  // eslint-disable-next-line eqeqeq
  elasticSearchAllowed: process.env.REACT_APP_ELASTIC_SEARCH_ALLOWED == "true",
};

const reducers = (state = defaultState, action) => {
  switch (action.type) {
    case SET_FEATURED_INSTAGRAM_POST:
      return { ...state, featuredInstagramPosts: action.payload };
    case SET_ABOUT_US_ENTITIES:
      return { ...state, aboutUsEntities: action.payload };
    case SET_ELASTICSEARCH_ENABLED:
      if (state.elasticSearchAllowed) {
        return { ...state, elasticSearchEnabled: action.payload };
      } else {
        return { ...state, elasticSearchEnabled: false };
      }
    default:
      return state;
  }
};
export default reducers;
